import React from 'react';
import MultiSelectDropdown from '../MultiSelectDropdown';

const FiltersBar = ({ filters, categories, materials, onChangeInput, onToggleTri, setFilters }) => {
  return (
    <div className="row mb-3 mt-3 g-2">
      <div className="col-md-3">
        <input
          type="text"
          className="form-control"
          name="namePart"
          placeholder="Поиск по артикулу или id"
          value={filters.namePart}
          onChange={onChangeInput}
        />
      </div>

      <div className="col-md-3">
        <MultiSelectDropdown
          options={categories}
          selectedIds={filters.categoryIds}
          onChange={(newIds) => setFilters({ ...filters, categoryIds: newIds, pageNumber: 1 })}
          placeholderAll="Все категории"
          placeholderOne="Категория"
          placeholderMany="категорий"
        />
      </div>

      <div className="col-md-3">
        <MultiSelectDropdown
          options={materials}
          selectedIds={filters.materialIds}
          onChange={(newIds) => setFilters({ ...filters, materialIds: newIds, pageNumber: 1 })}
          placeholderAll="Все материалы"
          placeholderOne="Материал"
          placeholderMany="материалов"
        />
      </div>

      <div className="col-md-3">
        <select
          className="form-control"
          name="sortParam"
          value={filters.sortParam}
          onChange={onChangeInput}
        >
          <option value="time_desc">Время (сначала новые)</option>
          <option value="time_asc">Время (сначала старые)</option>
          <option value="price_desc">Цена (по убыванию)</option>
          <option value="price_asc">Цена (по возрастанию)</option>
          <option value="article_desc">Артикул (по убыванию)</option>
          <option value="article_asc">Артикул (по возрастанию)</option>
        </select>
      </div>

      <div className="col-12 d-flex align-items-center gap-4 mt-2">
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={filters.hasItem === true}
            ref={(el) => el && (el.indeterminate = filters.hasItem === null)}
            onChange={() => onToggleTri('hasItem', filters.hasItem)}
          />
          <label className="form-check-label">Есть товар</label>
        </div>

        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={filters.hasCdrFile === true}
            ref={(el) => el && (el.indeterminate = filters.hasCdrFile === null)}
            onChange={() => onToggleTri('hasCdrFile', filters.hasCdrFile)}
          />
          <label className="form-check-label">Есть макет</label>
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;
